// @ts-nocheck
import React from "react";
import useAuth from '../../hooks/useAuth';
import { useTranslation } from "react-i18next";
import { Divider, List, Typography, Card, Flex, Carousel, ConfigProvider, Image } from 'antd';
import StoreList from "../../components/StoreList";
import GalleryVideoImg from "../../components/GalleryVideoImg";
import { Translate } from "../../services/translate";
import '../../styles/terms.css';

const TLSTruco = () => {

	window.scrollTo(0, 0);

	const { t, i18n: { changeLanguage, language } } = useTranslation();
	const { auth, habRoles } = useAuth();

	const hab_func = habRoles([]);

	const gallery_list = [
		{
			"link": "/img/apps/truco_01.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/truco_02.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/truco_03.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/truco_04.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/truco_05.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/truco_06.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/truco_07.jpeg",
			"video": false
		}
	];

	return (
		<div>
			<h2 className="title is-1">TLS Truco</h2>
			<br />
			<hr />
			<br />
			<StoreList
				//chrome_store={"https://chromewebstore.google.com/detail/ggogoinhjigamdpkogcjgkmlgcknlflb/preview?hl=pt-BR&authuser=1&pli=1"} 
				google_play={"https://play.google.com/store/apps/details?id=com.tlsengenharia.tlstruco"}
				apple_store={"https://apps.apple.com/br/app/tls-truco/id6761089885"}
				microsoft_store={""}
				download={""}
				hab_download={hab_func}
				user={auth?.user}
			/>
			<br />
			<div style={{ width: "100%" }}>
				<div style={{ maxWidth: 903, margin: "auto" }}>
					<GalleryVideoImg gallery_list={gallery_list} />
				</div>
			</div>
			<br />
			<br />
			<Flex wrap gap="middle" justify="center" align="center">
				<List
					style={{ maxWidth: 1200 }}
					size="large"
					header={<h2 className="title is-1">{t('visao_geral')}</h2>}
					bordered
					dataSource={[<></>]}
					renderItem={(item: any) => <List.Item>{
						language == "pt-BR" ?
							(
								<>
									<div className='term_just'>
										<strong>TLS Truco</strong> é o aplicativo definitivo para quem ama jogar Truco em qualquer lugar!<br />
										Simples, rápido e completo, ele reúne tudo o que os truqueiros precisam para jogar partidas, marcar pontos e organizar torneios entre amigos de forma prática e intuitiva.
										<br />
										<br />
										O aplicativo oferece suporte ao <strong>Truco Paulista</strong>, permitindo jogar exatamente no estilo que você e seus amigos estão acostumados.
										<br />
										<br />
										<h3>Recursos:</h3><br />
										<ul>
											<li><strong>Partidas com IA Inteligente:</strong> Jogue contra adversários controlados por inteligência artificial, capazes de blefar, pedir truco e reagir ao seu estilo de jogo.</li>
											<li><strong>Marcador de Pontos:</strong> Controle a pontuação das partidas com rapidez e praticidade.</li>
											<li><strong>Organização de Torneios:</strong> Registre partidas e acompanhe os vencedores de cada rodada em torneios entre amigos.</li>
											<li><strong>Personalização de Regras:</strong> Ajuste configurações como mão de 11 e outras opções para adaptar o jogo ao seu grupo.</li>
											<li><strong>Interface Moderna:</strong> Layout rápido, leve e otimizado para dispositivos móveis.</li>
										</ul>
										<br />
										Seja para jogar sozinho contra a IA, marcar partidas com os amigos ou organizar torneios, o TLS Truco oferece uma experiência completa e fiel às tradições do Truco brasileiro.
									</div>
								</>
							)
							:
							language == "es" ?
								(
									<div className='term_just'>
										<strong>TLS Truco</strong> es la aplicación definitiva para quienes aman jugar Truco en cualquier lugar.<br />
										Simple, rápida y completa, reúne todo lo que los jugadores necesitan para disputar partidas, llevar la puntuación y organizar torneos entre amigos de manera práctica e intuitiva.
										<br />
										<br />
										La aplicación es compatible con el <strong>Truco Paulista</strong>, permitiendo jugar exactamente con el estilo tradicional que conocen los jugadores.
										<br />
										<br />
										<h3>Funciones:</h3><br />
										<ul>
											<li><strong>Partidas con IA Inteligente:</strong> Juega contra oponentes controlados por inteligencia artificial capaces de engañar, cantar truco y adaptarse a tu estilo de juego.</li>
											<li><strong>Marcador de Puntos:</strong> Lleva la puntuación de las partidas de forma rápida y sencilla.</li>
											<li><strong>Organización de Torneos:</strong> Registra partidas y sigue a los ganadores de cada ronda en torneos entre amigos.</li>
											<li><strong>Personalización de Reglas:</strong> Configura opciones como la mano de 11 y otras reglas personalizadas.</li>
											<li><strong>Interfaz Moderna:</strong> Diseño rápido, ligero y optimizado para dispositivos móviles.</li>
										</ul>
										<br />
										Ya sea para jugar solo contra la IA, disfrutar partidas con amigos o gestionar torneos informales, TLS Truco ofrece una experiencia completa y fiel a las tradiciones del Truco brasileño.
									</div>
								)
								:
								(
									<div className='term_just'>
										<strong>TLS Truco</strong> is the ultimate app for anyone who loves playing Truco anytime, anywhere!<br />
										Simple, fast, and complete, it brings together everything Truco players need to play matches, keep score, and organize tournaments with friends in a practical and intuitive way.
										<br />
										<br />
										The app supports <strong>Truco Paulista</strong>, allowing players to enjoy the traditional style they know and love.
										<br />
										<br />
										<h3>Features:</h3><br />
										<ul>
											<li><strong>Smart AI Matches:</strong> Play against intelligent opponents capable of bluffing, calling Truco, and adapting to your playing style.</li>
											<li><strong>Score Tracker:</strong> Keep match scores quickly and accurately.</li>
											<li><strong>Tournament Management:</strong> Record matches and track winners throughout friendly tournaments.</li>
											<li><strong>Rule Customization:</strong> Configure options such as the 11-point hand and other game settings.</li>
											<li><strong>Modern Interface:</strong> Fast, lightweight, and optimized for mobile devices.</li>
										</ul>
										<br />
										Whether you want to play against AI, keep score during matches with friends, or organize tournaments, TLS Truco delivers a complete experience inspired by the traditions of Brazilian Truco.
									</div>
								)
					}
					</List.Item>}
				/>
			</Flex>
		</div>
	);
}


export default TLSTruco